import { store } from '../../../core/Store';
import { IAdress, IPersonalInfo } from '../../../models/PersonalInfo';
import { Actions, Selectors } from '.';
import {
	validateStringGenericEssential,
	validateStringEmail,
	validateStringPesel,
	validateStringPhone,
	validateStringPostal,
	validateStringHouseNo,
	validateStringGenericAny,
	validateStringNip,
} from '../../../core/validators';

type PersonalInfoKey = keyof Omit<
	IPersonalInfo,
	'correspondenceAddress' | 'residentalAddress' | 'plCitizenship'
>;

export const validatePersonalInfoField = (
	field: PersonalInfoKey,
	skipBusiness?: boolean
) => {
	const state = store.getState();
	const personalInfoData = Selectors.getPersonalInfo(state);
	const personalInfoErrors = Selectors.getPersonalInfoErrors(state);
	switch (field) {
		case 'firstName':
			store.dispatch(
				Actions.setPersonalInfoErrors({
					...personalInfoErrors,
					firstName: validateStringGenericEssential(
						personalInfoData[field]
					)
						? ''
						: 'imie musi zawierać przynajmniej 3 znaki',
				})
			);
			break;
		case 'lastName':
			store.dispatch(
				Actions.setPersonalInfoErrors({
					...personalInfoErrors,
					lastName: validateStringGenericEssential(
						personalInfoData[field]
					)
						? ''
						: 'nazwisko musi zawierać przynajmniej 3 znaki',
				})
			);
			break;
		case 'email':
			store.dispatch(
				Actions.setPersonalInfoErrors({
					...personalInfoErrors,
					email: validateStringEmail(personalInfoData[field])
						? ''
						: 'podany email nie jest poprawny',
				})
			);
			break;
		case 'pesel':
			store.dispatch(
				Actions.setPersonalInfoErrors({
					...personalInfoErrors,
					pesel: validateStringPesel(personalInfoData[field])
						? ''
						: 'podany PESEL nie jest poprawny',
				})
			);
			break;
		case 'phone':
			store.dispatch(
				Actions.setPersonalInfoErrors({
					...personalInfoErrors,
					phone: validateStringPhone(personalInfoData[field])
						? ''
						: 'podany numer tel. nie jest poprawny',
				})
			);
			break;
		case 'businessName':
			store.dispatch(
				Actions.setPersonalInfoErrors({
					...personalInfoErrors,
					businessName: skipBusiness
						? ''
						: validateStringGenericEssential(
								personalInfoData[field]
						  )
						? ''
						: 'podana nazwa działalności nie jest poprawna',
				})
			);
			break;
		case 'nip':
			store.dispatch(
				Actions.setPersonalInfoErrors({
					...personalInfoErrors,
					nip: skipBusiness
						? ''
						: validateStringNip(personalInfoData[field])
						? ''
						: 'podany numer NIP nie jest poprawny',
				})
			);
			break;
		default:
			break;
	}
};

export const validatePersonalInfoAdressField = (field: keyof IAdress) => {
	const state = store.getState();
	const personalInfoRAdressData =
		Selectors.getPersonalInfo(state).residentalAddress;
	const personalInfoRAdressErrors =
		Selectors.getPersonalInfoRAdressErrors(state);

	switch (field) {
		case 'city': {
			const payload = {
				...personalInfoRAdressErrors,
				city: validateStringGenericEssential(
					personalInfoRAdressData && personalInfoRAdressData[field]
				)
					? ''
					: 'podane miasto nie jest poprawne',
			};
			store.dispatch(Actions.setPersonalInfoRAdressErrors(payload));
			break;
		}
		case 'postalCode': {
			const payload = {
				...personalInfoRAdressErrors,
				postalCode: validateStringPostal(
					personalInfoRAdressData && personalInfoRAdressData[field]
				)
					? ''
					: 'podany kod pocztowy nie jest poprawny (poprawny format: 00-000)',
			};
			store.dispatch(Actions.setPersonalInfoRAdressErrors(payload));
			break;
		}
		case 'houseNo':
			const payload = {
				...personalInfoRAdressErrors,
				houseNo: validateStringHouseNo(
					personalInfoRAdressData && personalInfoRAdressData[field]
				)
					? ''
					: 'podany numer domu nie jest poprawny',
			};
			store.dispatch(Actions.setPersonalInfoRAdressErrors(payload));
			break;
		case 'appartmentNo': {
			const payload = {
				...personalInfoRAdressErrors,
				appartmentNo: validateStringGenericAny(
					personalInfoRAdressData && personalInfoRAdressData[field]
				)
					? ''
					: 'podana numer lokalu nie jest poprawny',
			};
			store.dispatch(Actions.setPersonalInfoRAdressErrors(payload));
			break;
		}
		default:
			break;
	}
};

export const validateForm = () => {
	const hasBusiness = Selectors.getHasBusiness(store.getState());

	validatePersonalInfoField('firstName');
	validatePersonalInfoField('lastName');
	validatePersonalInfoField('pesel');
	validatePersonalInfoField('email');
	validatePersonalInfoField('phone');

	validatePersonalInfoField('businessName', !hasBusiness);
	validatePersonalInfoField('nip', !hasBusiness);

	validatePersonalInfoAdressField('appartmentNo');
	validatePersonalInfoAdressField('city');
	validatePersonalInfoAdressField('houseNo');
	validatePersonalInfoAdressField('postalCode');
	validatePersonalInfoAdressField('street');
};
